import IconeApregoar from '@mui/icons-material/Cast';
import IconeApregoado from '@mui/icons-material/CastConnected';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import IconeDetalhePregao from '@/components/icones/IconeDetalhePregao';
import { ABAS_DETALHES_PROCESSO } from '@/dominio/AbasDetalhesProcesso';

class Apregoar extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            processo: computed,
            processoApregoado: computed,
            handleApregoar: action,
            tooltipApregoar: computed,
            isProcessoApregoado: computed,
            handleClickIconeDetalhesProcessoApregoado: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get processo() {
        return this.registro.processo;
    }

    get processoApregoado() {
        return this.sessaoStore.processoApregoado;
    }

    handleApregoar = () => {
        const podeApregoar = this.salaSessaoStore.isPermitidaApreciacaoProcesso(this.registro);

        if (!this.isProcessoApregoado && !this.registro.necessitaImportacaoSalaSessao && podeApregoar) {
            this.salaSessaoStore.apregoar(this.registro);
            this.salaSessaoStore.abaSelecionadaDetalhesProcesso = ABAS_DETALHES_PROCESSO.PROCESSO.id;
        }
    };

    get tooltipApregoar() {
        return (
            <>
                <Typography>{this.isProcessoApregoado ? 'Apregoado' : 'Apregoar'}</Typography>
                {this.registro.sequencialApregoamento && (
                    <Typography display={'inline'}>
                        (Sequencial de apregoamento: {this.registro.sequencialApregoamento})
                    </Typography>
                )}
            </>
        );
    }

    get isProcessoApregoado() {
        return (
            this.processoApregoado && this.processo.numeroCompleto === this.processoApregoado.processo.numeroCompleto
        );
    }

    handleClickIconeDetalhesProcessoApregoado = () => {
        this.handleApregoar();
        this.salaSessaoStore.detalhesProcessoApregoado = this.registro;
        this.salaSessaoStore.dialogDetalhesProcessoApregoadoOpen = true;
    };

    render() {
        const podeApregoar = this.salaSessaoStore.isPermitidaApreciacaoProcesso(this.registro);

        return (
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                <Tooltip
                    placement="top"
                    title={this.tooltipApregoar}
                >
                    {podeApregoar && (
                        <Box
                            onClick={this.handleApregoar}
                            style={{ cursor: 'pointer' }}
                        >
                            {this.isProcessoApregoado ? <IconeApregoado /> : <IconeApregoar />}
                        </Box>
                    )}
                </Tooltip>
                {this.observableProps.exibirBotaoDetalhePregao && (
                    <Tooltip
                        title={
                            this.isProcessoApregoado
                                ? 'Ver detalhes do processo apregoado'
                                : 'Apregoar e exibir detalhes do processo'
                        }
                        placement="top"
                    >
                        <Button
                            onClick={this.handleClickIconeDetalhesProcessoApregoado}
                            sx={{
                                minWidth: 'auto',
                                padding: 0,
                                mt: '3px'
                            }}
                        >
                            <IconeDetalhePregao apregoado={this.isProcessoApregoado} />
                        </Button>
                    </Tooltip>
                )}
            </Box>
        );
    }
}

export default inject('stores')(observer(Apregoar));
